



































































































import { Component, Vue } from 'vue-property-decorator';

import DraggableWidget from '@/components/util/DraggableWidget.vue';

import { mapGetters } from 'vuex';

import {
  WorkordersApi,
  UsersApi,
  QueryWorkOrdersRequest,
  WorkorderPagedCollectionApiResponse,
  User as PerformoUser,
  UserCustomWorkorderFilter,
  ValidationProblemDetails
} from 'performo-api';

@Component({
  components: {
    DraggableWidget
  },
  computed: mapGetters({
    currentPropertyId: 'currentPropertyId',
    currentUser: 'currentUser',
    performoUser: 'performoUser',
    ordersApi: 'ordersApi',
    usersApi: 'usersApi',
    settings: 'settings'
  })
})
export default class WorkerCustomFilterButtonsWidget extends Vue {
  private ordersApi!: WorkordersApi;
  private usersApi!: UsersApi;
  private performoUser!: PerformoUser;
  private currentPropertyId!: string;
  private customFilters!: UserCustomWorkorderFilter[];
  private problems: ValidationProblemDetails = [];
  private inEditMode = false;
  private showDialog = false;
  private loading = false;
  private filterToDelete = '';

  data() {
    return {
      inEditMode: undefined
    };
  }

  get customFilterButtons() {
    if (this.performoUser.customFilterButtons) {
      this.customFilters = this.performoUser.customFilterButtons;
      this.customFilters?.forEach(async (element) => {
        const pagedOrders: WorkorderPagedCollectionApiResponse =
          await this.ordersApi.queryWorkOrders(
            element.query as QueryWorkOrdersRequest
          );
        element.count = pagedOrders.pagination?.totalItems;
      });
    }

    return this.customFilters.filter(
      (btn) =>
        btn.query?.propertyId === this.currentPropertyId ||
        btn.query?.propertyId === 'All'
    );
  }

  private async handleDeleteFilter() {
    try {
      this.loading = true;
      const userDeletedFilter = await this.usersApi.deleteCustomFilter({
        deleteUserCustomFilterCommand: {
          userId: this.$store.state.performoUser.userId,
          customFilterTitle: this.filterToDelete
        }
      });
      this.$store.commit('setPerformoUser', userDeletedFilter);
      this.showDialog = false;
      this.loading = false;
    } catch (error) {
      this.editorError(error as ValidationProblemDetails);
    }
  }

  private openDeleteDialog(filterTitle: string) {
    this.filterToDelete = filterTitle;
    this.showDialog = true;
  }

  private toggleEditMode() {
    this.inEditMode = !this.inEditMode;
  }

  private async editorError(error: ValidationProblemDetails | Response) {
    if (!error) {
      return;
    }

    let vpd: ValidationProblemDetails;
    if (error instanceof Response) {
      vpd = await error.json();
    } else {
      vpd = error;
    }
    this.problems = vpd;
  }

  private doCustomFilterButtonsWidget() {
    // blank
  }
}
